import * as React from "react";
import { useState, useEffect, useMemo, useCallback } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { AnyForNow } from "../../features/grn/types";
import {
  Box,
  Typography,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  MenuItem,
  Select,
  Divider,
  IconButton,
  Collapse,
  InputAdornment,
  Tooltip,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import {
  ExpandMore,
  ExpandLess,
  Search as SearchIcon,
} from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";
import QrCodeScannerOutlinedIcon from "@mui/icons-material/QrCodeScannerOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImagePopUp from "./grnpopup/ImagePopUp";
import { useSelector } from "react-redux";
import SystemAlert from "../../components/common/SystemAlert";
import Upload from "../common/Upload";
import { GRN_API_01, SETTING_API_17, UPLOAD_API } from "../../api/ApiModel";
import {
  externalgetApi,
  externalImagepostApi,
} from "../../services/externalApis";
import {
  CON_DEFAULT_IMG,
  CON_STATUS_ACTIVE,
  CON_STATUS_RETURNAPPROVED,
  CON_STATUS_RETURNSUBMITTED,
} from "../../utils/sys/Constants";
import { isImageFile, parseJsonArray } from "../../utils/grn/fileUtils";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import { useNavigate } from "react-router-dom";
import { ITEM_LABELS } from "../../utils/sys/GrnLabels";
import { GRN_VIEW_RETURN_FILTER } from "../../utils/sys/GrnConstants";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";

interface ReturnItemsTableProps {
  items: AnyForNow;
  grncode: string;
  onSave: AnyForNow;
  setReturnedProducts: AnyForNow;
  returnedProducts?: AnyForNow;
  isReReturn?: boolean;
  previousReturnDetails?: AnyForNow[];
  trsts?: string;
  returns?: AnyForNow[];
  trcatcode?: string;
  onSelectionChange?: (selectedData: AnyForNow[]) => void; // ← add
  onCheckedRowsChange?: (hasCheckedRows: boolean) => void;
  origin?: string; // ← add origin prop
  showSelectionValidationError?: boolean;
}

const ReturnItemsTableviewdet: React.FC<ReturnItemsTableProps> = (props) => {
  const {
    items,
    grncode,
    trsts,
    trcatcode,
    onSave,
    setReturnedProducts,
    returnedProducts,
    isReReturn = false,
    previousReturnDetails = [],
    returns,
    origin,
    showSelectionValidationError = false,
  } = props;

  const safeItems = useMemo(() => (Array.isArray(items) ? items : []), [items]);
  const [dtoDocs, setDtoDocs] = useState<AnyForNow[]>(
    Array(safeItems.length).fill(null),
  );
  const [filePath, setFilePath] = useState<string>("");
  const theme = useTheme();
  const navigate = useNavigate();
  const styles = useStyles(theme);
  const [rows, setRows] = useState<AnyForNow[]>(safeItems);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<string>("success");
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [imagePopupOpen, setImagePopupOpen] = useState<boolean>(false);
  const [popupImage, setPopupImage] = useState<AnyForNow>(null);
  const [popupName, setPopupName] = useState<string>("");
  const [popupDescription, setPopupDescription] = useState<string>("");
  const [showGrnItems, setShowGrnItems] = useState<boolean>(true);
  const [expandedOptional, setExpandedOptional] = React.useState<{
    [key: number]: boolean;
  }>({});
  const [search, setSearch] = useState<string>("");
  const [fileName, setFileName] = useState<AnyForNow[]>([]);
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { STAFFMAPLOCODE, COMPCODE } = SYS_USER.USER_PARAM || {};
  const [showRemarkItems, setShowRemarkItems] = useState<boolean[]>(
    Array(safeItems.length).fill(false),
  );
  const [anchorEl, setAnchorEl] = useState<{
    [key: number]: HTMLElement | null;
  }>({});
  const [showItemAttachments, setItemAttachments] = useState<boolean[]>(
    Array(safeItems.length).fill(false),
  );
  const [savedStatus, setSavedStatus] = useState<boolean[]>(
    Array(safeItems.length).fill(false),
  );
  const [selectedImage, setSelectedImage] = useState<AnyForNow>(null);
  const [imagePreviewOpen, setImagePreviewOpen] = useState<boolean>(false);

  // ── NEW: per-row checkbox selection ──────────────────────────────────────
  const [selectedRows, setSelectedRows] = useState<boolean[]>(
    Array(safeItems.length).fill(false),
  );

  const storedReturnProducts = useMemo(
    () =>
      parseJsonArray<AnyForNow>(
        localStorage.getItem("returnedProducts"),
      ).filter((item) => item && Number(item.returnedqty) > 0),
    [returnedProducts],
  );

  const toggleOptionalFields = (index: number) => {
    setExpandedOptional((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const toggleShowGrnItems = () => setShowGrnItems((prev) => !prev);

  const [reasons, setReasons] = useState<string[]>(rows.map(() => ""));
  const [returnQuantities, setReturnQuantities] = useState<string[]>(
    rows.map(() => ""),
  );
  const [quantityErrors, setQuantityErrors] = useState<string[]>(
    rows.map(() => ""),
  );
  const [returnRemarks, setReturnRemarks] = useState<string[]>(
    rows.map(() => ""),
  );
  const [returnRemarkErrors, setReturnRemarkErrors] = useState<string[]>(
    rows.map(() => ""),
  );
  const [reasonOptions, setReasonOptions] = useState<AnyForNow[]>([]);
  const [grndet, setgrndet] = useState<AnyForNow[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // ── Sync selectedRows length when rows change ─────────────────────────────
  useEffect(() => {
    setSelectedRows((prev) => {
      if (prev.length !== safeItems.length)
        return Array(safeItems.length).fill(false);
      return prev;
    });
  }, [safeItems.length]);

  console.log("ee3", returns);

  useEffect(() => {
    if (!rows.length || !storedReturnProducts.length) return;
    const productMap = new Map(
      storedReturnProducts.map((stored) => [
        String(stored.supproductcode),
        stored,
      ]),
    );
    const getFromMap = <T,>(extractor: (item?: AnyForNow) => T): T[] =>
      rows.map((row) => extractor(productMap.get(String(row.supproductcode))));

    setReturnQuantities(
      getFromMap((match) =>
        match && match.returnedqty !== undefined
          ? String(match.returnedqty)
          : "",
      ),
    );
    setReasons(getFromMap((match) => match?.reason || ""));
    setDtoDocs((prev) =>
      rows.map((row, index) => {
        const match = productMap.get(String(row.supproductcode));
        if (match?.dtoDOCs?.[0]) return match.dtoDOCs[0];
        return prev[index] !== undefined ? prev[index] : null;
      }),
    );
    setReturnRemarks(getFromMap((match) => match?.remarks || ""));
    setSavedStatus(
      rows.map((row) => productMap.has(String(row.supproductcode))),
    );
    setSelectedRows(
      rows.map((row) => {
        const match = productMap.get(String(row.supproductcode));
        return Boolean(match && Number(match.returnedqty) > 0);
      }),
    );
  }, [rows, storedReturnProducts]);

  useEffect(() => {
    setRows(safeItems);
  }, [safeItems]);

  useEffect(() => {
    setReasons((prev) =>
      prev.length !== rows.length ? Array(rows.length).fill("") : prev,
    );
  }, [rows]);

  useEffect(() => {
    const newLength = rows.length;
    setReturnQuantities((prev) =>
      prev.length !== newLength ? Array(newLength).fill("") : prev,
    );
    setQuantityErrors((prev) =>
      prev.length !== newLength ? Array(newLength).fill("") : prev,
    );
  }, [rows]);

  useEffect(() => {
    if (isReReturn && rows.length > 0) {
      setReturnQuantities(rows.map(() => ""));
      setReasons(rows.map(() => ""));
    }
  }, [isReReturn]);

  useEffect(() => {
    setDtoDocs((prev) =>
      prev.length !== safeItems.length
        ? Array(safeItems.length).fill(null)
        : prev,
    );
  }, [safeItems]);

  useEffect(() => {
    const fetchgrn = async () => {
      try {
        const result = await externalgetApi(GRN_API_01, "get", {
          COMPCODE,
          GRNCODE: grncode,
          STS: CON_STATUS_ACTIVE,
        });
        const rawData = Array.isArray(result) ? result : [result];
        const returnsData = rawData.flatMap(
          (item) => item.returnList || item.returns || [],
        );
        setgrndet(returnsData);

        if (
          origin !== "ReturnGrn" &&
          returnsData.length > 0 &&
          Array.isArray(rows) &&
          rows.length > 0 &&
          !isReReturn
        ) {
          setReturnQuantities(
            rows.map((row) => {
              const m = returnsData.find(
                (r) => r.supproductcode === row.supproductcode,
              );
              return m ? m.returnedqty || "" : "";
            }),
          );
          setReasons(
            rows.map((row) => {
              const m = returnsData.find(
                (r) => r.supproductcode === row.supproductcode,
              );
              return m ? m.reason || "" : "";
            }),
          );
          setReturnRemarks(
            rows.map((row) => {
              const m = returnsData.find(
                (r) => r.supproductcode === row.supproductcode,
              );
              return m ? m.descrip || "" : "";
            }),
          );
          setDtoDocs(
            rows.map((row) => {
              const match = returnsData.find(
                (r) => r.supproductcode === row.supproductcode,
              );
              if (match && match.docpathjson) {
                try {
                  const parsedDocs = JSON.parse(match.docpathjson);
                  const doc = parsedDocs[0];
                  return {
                    doctypecode: doc?.DOCTYPECODE || "0",
                    doctypeothername: doc?.DOCTYPEOTHERNAME || "",
                    docpathjson: match.docpathjson,
                    filename: doc?.FILENAME || "",
                    FILEPATH: doc?.FILEPATH || "",
                    remark: doc?.REMARK || "",
                    fileUrl: doc?.FILEPATH || "",
                    bytarr: "",
                    supproductcode: row.supproductcode,
                  };
                } catch {
                  return null;
                }
              }
              return null;
            }),
          );
        }

        if (isReReturn && Array.isArray(rows) && rows.length > 0) {
          setReturnQuantities(rows.map(() => ""));
          setReasons(rows.map(() => ""));
        }
      } catch (error) {
        console.error("Error fetching GRN returns:", error);
        setgrndet([]);
      } finally {
        setLoading(false);
      }
    };
    if (grncode) fetchgrn();
  }, [grncode, rows, isReReturn]);

  useEffect(() => {
    const fetchReasons = async () => {
      try {
        const result = await externalgetApi(SETTING_API_17, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          reasoncatcode: 6,
          STS: CON_STATUS_ACTIVE,
        });
        setReasonOptions(result || []);
      } catch {
        setReasonOptions([]);
      } finally {
        setLoading(false);
      }
    };
    fetchReasons();
  }, [COMPCODE, STAFFMAPLOCODE]);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    index: number,
  ) => setAnchorEl((prev) => ({ ...prev, [index]: event.currentTarget }));
  const handleMenuClose = (index: number) =>
    setAnchorEl((prev) => ({ ...prev, [index]: null }));

  const uploadAttachmentFile = async (
    rawFile: File | null,
  ): Promise<string> => {
    if (!rawFile) return "";
    const formData = new FormData();
    formData.append("file", rawFile);
    const response = await externalImagepostApi(UPLOAD_API, formData);
    return response?.filepath || response?.filePath || response?.FILEPATH || "";
  };

  const hasActualAttachment = (doc: AnyForNow): boolean => {
    if (!doc) return false;
    const hasFilePath =
      typeof doc.FILEPATH === "string" &&
      doc.FILEPATH.trim() !== "" &&
      !doc.FILEPATH.includes("noimage.png");
    const hasFileUrl =
      typeof doc.fileUrl === "string" && doc.fileUrl.trim() !== "";
    const hasBytarr = typeof doc.bytarr === "string" && doc.bytarr.trim() !== "";
    const hasDocPathJson =
      typeof doc.docpathjson === "string" && doc.docpathjson.trim() !== "";
    return (
      doc.doctypecode !== "0" &&
      (hasFilePath || hasFileUrl || hasBytarr || hasDocPathJson)
    );
  };

  const handleFileSelect = async (
    fileName: string,
    base64DataURL: string,
    rawFile: File,
    itemIndex: number,
  ) => {
    if (hasActualAttachment(dtoDocs[itemIndex])) {
      setAlertMessage("Only one attachment is allowed.");
      setAlertType("warning");
      setAlertOpen(true);
      return;
    }
    setDtoDocs((prev) => {
      const updated = [...prev];
      updated[itemIndex] = { uploading: true };
      return updated;
    });
    const base64Only = base64DataURL.split(",")[1];
    let uploadedPath = "";
    try {
      uploadedPath = await uploadAttachmentFile(rawFile);
    } catch {
      setAlertMessage("File upload failed.");
      setAlertType("error");
      setAlertOpen(true);
      setDtoDocs((prev) => {
        const updated = [...prev];
        updated[itemIndex] = null;
        return updated;
      });
      return;
    }
    const usePathOnly = Boolean(uploadedPath && uploadedPath.trim());
    const newDtoDoc = {
      doctypecode: "6",
      docpathjson: usePathOnly ? uploadedPath.trim() : base64Only,
      filename: uploadedPath,
      doctypeothername: "",
      bytarr: usePathOnly ? "" : base64Only,
      remark: "",
      FILEPATH: uploadedPath,
      fileUrl: uploadedPath,
      supproductcode: safeItems[itemIndex]?.supproductcode,
      isNew: true,
    };
    setDtoDocs((prev) => {
      const updated = [...prev];
      updated[itemIndex] = newDtoDoc;
      return updated;
    });
    setFileName((prev) => {
      const updated = [...prev];
      updated[itemIndex] = fileName;
      return updated;
    });
  };

  const handleItemAttachmentRemove = (itemIndex: number) => {
    setDtoDocs((prev) => {
      const updated = [...prev];
      updated[itemIndex] = null;
      return updated;
    });
    setFileName((prev) => {
      const updated = [...prev];
      updated[itemIndex] = "No file selected";
      return updated;
    });
    setFilePath("");
  };

  const removeItemFromTable = (index: number) => {
    const productCode = rows[index]?.supproductcode;
    setReturnQuantities((prev) => {
      const u = [...prev];
      u[index] = "";
      return u;
    });
    setQuantityErrors((prev) => {
      const u = [...prev];
      u[index] = "";
      return u;
    });
    setReasons((prev) => {
      const u = [...prev];
      u[index] = "";
      return u;
    });
    setReturnRemarks((prev) => {
      const u = [...prev];
      u[index] = "";
      return u;
    });
    setDtoDocs((prev) => {
      const u = [...prev];
      u[index] = null;
      return u;
    });
    setFileName((prev) => {
      const u = [...prev];
      u[index] = "No file selected";
      return u;
    });
    setFilePath("");
    // Deselect the row
    setSelectedRows((prev) => {
      const u = [...prev];
      u[index] = false;
      return u;
    });
    const storedProducts = JSON.parse(
      localStorage.getItem("returnedProducts") || "[]",
    );
    const updatedStoredProducts = storedProducts.filter(
      (item: AnyForNow) => item.supproductcode !== productCode,
    );
    localStorage.setItem(
      "returnedProducts",
      JSON.stringify(updatedStoredProducts),
    );
    if (typeof setReturnedProducts === "function")
      setReturnedProducts(updatedStoredProducts);
    setSavedStatus((prev) => {
      const u = [...prev];
      u[index] = false;
      return u;
    });
  };

  const getBase64ImageSrc = (base64: string, filename: string = "") => {
    const ext = filename.split(".").pop()?.toLowerCase();
    const mime =
      ext === "jpg" || ext === "jpeg"
        ? "image/jpeg"
        : ext === "png"
        ? "image/png"
        : "image/*";
    return `data:${mime};base64,${base64}`;
  };

  // ── Checkbox helpers ──────────────────────────────────────────────────────
  const allFilteredSelected = useMemo(() => {
    const filteredIndexes = filteredItemIndexes();
    return (
      filteredIndexes.length > 0 &&
      filteredIndexes.every((i) => selectedRows[i])
    );
  }, [selectedRows, search]);

  const someFilteredSelected = useMemo(() => {
    const filteredIndexes = filteredItemIndexes();
    return filteredIndexes.some((i) => selectedRows[i]) && !allFilteredSelected;
  }, [selectedRows, search, allFilteredSelected]);

  function filteredItemIndexes() {
    const s = (search || "").toLowerCase();
    return safeItems
      .map((item, i) => ({ item, i }))
      .filter(
        ({ item }) =>
          (item.productname && item.productname.toLowerCase().includes(s)) ||
          (item.productcode && item.productcode.toLowerCase().includes(s)) ||
          (item.brandname && item.brandname.toLowerCase().includes(s)) ||
          (item.batchno && item.batchno.toLowerCase().includes(s)),
      )
      .map(({ i }) => i);
  }

  const handleSelectAll = (checked: boolean) => {
    const indexes = filteredItemIndexes();
    setSelectedRows((prev) => {
      const updated = [...prev];
      indexes.forEach((i) => (updated[i] = checked));
      return updated;
    });
  };

  const handleRowSelect = (index: number, checked: boolean) => {
    setSelectedRows((prev) => {
      const updated = [...prev];
      updated[index] = checked;
      return updated;
    });
  };
  const isPreFilled = (idx: number) =>
    Boolean(returnQuantities[idx] && Number(returnQuantities[idx]) > 0);

  const shouldShowSelectionError =
    showSelectionValidationError && !selectedRows.some(Boolean);
  // ── Single Save for all selected rows ────────────────────────────────────
  const handleSubmit = async () => {
    const dtProductReturns = safeItems
      .map((data, idx) => {
        // Only include rows that are checked AND have a return quantity > 0
        if (!selectedRows[idx]) return null;
        const returnQty = Number(returnQuantities[idx]) || 0;
        if (returnQty === 0) return null;

        return {
          supproductcode: data.supproductcode,
          returnedqty: returnQty,
          descrip: returnRemarks[idx] || "",
          dtoDOCs: dtoDocs[idx]
            ? [dtoDocs[idx]]
            : [
                {
                  doctypecode: "0",
                  doctypeothername: "",
                  docpathjson: "",
                  filename: "",
                  bytarr: "",
                  remark: "",
                },
              ],
          remarks: returnRemarks[idx] || "",
          reason: reasons[idx] || "",
        };
      })
      .filter(Boolean);

    if (dtProductReturns.length === 0) {
      setSavedStatus(Array(safeItems.length).fill(false));
      setAlertType("error");
      setAlertMessage(
        "Please select items and enter a return quantity for at least one item.",
      );
      setAlertOpen(true);
      return;
    }

    if (onSave) {
      onSave({ dtProductReturns });
      const updatedSavedStatus = rows.map((row) => {
        const match = dtProductReturns.find(
          (savedItem: AnyForNow) =>
            savedItem.supproductcode === row.supproductcode,
        );
        return Boolean(match);
      });
      setSavedStatus(updatedSavedStatus);
    }

    setFileName([]);
    setFilePath("");
  };

  const buildSelectedItems = useCallback(() => {
    return safeItems
      .map((data, idx) => {
        if (!selectedRows[idx]) return null;
        const returnQty = Number(returnQuantities[idx]) || 0;
        if (returnQty === 0) return null;
        return {
          supproductcode: data.supproductcode,
          returnedqty: returnQty,
          descrip: returnRemarks[idx] || "",
          dtoDOCs: dtoDocs[idx]
            ? [dtoDocs[idx]]
            : [
                {
                  doctypecode: "0",
                  doctypeothername: "",
                  docpathjson: "",
                  filename: "",
                  bytarr: "",
                  remark: "",
                },
              ],
          remarks: returnRemarks[idx] || "",
          reason: reasons[idx] || "",
        };
      })
      .filter(Boolean);
  }, [
    safeItems,
    selectedRows,
    returnQuantities,
    returnRemarks,
    dtoDocs,
    reasons,
  ]);

  useEffect(() => {
    props.onSelectionChange?.(buildSelectedItems());
  }, [selectedRows, returnQuantities, reasons, returnRemarks, dtoDocs]);

  useEffect(() => {
    const hasAnyChecked = selectedRows.some(Boolean);
    props.onCheckedRowsChange?.(hasAnyChecked);
  }, [selectedRows]);

  const filteredItems = safeItems.filter((item) => {
    const s = (search || "").toLowerCase();
    return (
      (item.productname && item.productname.toLowerCase().includes(s)) ||
      (item.productcode && item.productcode.toLowerCase().includes(s)) ||
      (item.brandname && item.brandname.toLowerCase().includes(s)) ||
      (item.batchno && item.batchno.toLowerCase().includes(s))
    );
  });

  // Count selected items that also have qty > 0
  const selectedCount = selectedRows.filter(
    (checked, i) => checked && Number(returnQuantities[i]) > 0,
  ).length;

  return (
    <>
      <Paper
        variant="outlined"
        sx={{ borderRadius: 2, overflow: "hidden", borderColor: "divider" }}
      >
        {/* ── Top bar ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.25,
            bgcolor: "background.paper",
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={toggleShowGrnItems}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "0.78rem",
                letterSpacing: "0.09em",
                color: "text.secondary",
              }}
            >
              Return Items
            </Typography>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", sm: "auto", md: 360 },
              display: "flex",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              size="small"
              placeholder="Search by item name, code, or batch number..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 5,
                  fontSize: "0.82rem",
                  bgcolor: "background.default",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      fontSize="small"
                      sx={{ color: "text.disabled" }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        <Collapse in={showGrnItems} timeout="auto" unmountOnExit>
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              boxShadow: "none",
              borderTop: `1px solid`,
              borderColor: "divider",
              borderRadius: 0,
            }}
          >
            <Table sx={{ minWidth: 900 }}>
              {/* ── Header ── */}
              <TableHead>
                <TableRow sx={{ bgcolor: theme.palette.background.default }}>
                  {/* Select All checkbox */}
                  <TableCell
                    align="center"
                    sx={{ px: 1, width: 52, borderBottom: "none" }}
                  >
                    {/* <Checkbox
                      size="small"
                      checked={allFilteredSelected}
                      indeterminate={someFilteredSelected}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      sx={{ color: "text.disabled", "&.Mui-checked": { color: "primary.main" } }}
                    /> */}
                  </TableCell>
                  {[
                    { label: "", width: 60, align: "center" },
                    { label: "Item Details", width: 180 },
                    { label: "⁠Item Description (Variant)", width: 100 },
                    { label: "Batch Number", width: 140 },
                    {
                      label: "Returnable Quantity",
                      width: 150,
                      align: "center",
                    },
                    { label: "Return Quantity", width: 180, align: "center" },
                    { label: "Reason for Return", width: 180 },
                    { label: "Remark", width: 170 },
                    { label: "Action", width: 80, align: "center" },
                  ].map((col) => (
                    <TableCell
                      key={col.label}
                      align={(col.align as any) || "left"}
                      sx={{
                        py: 1.5,
                        px: 1.5,
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                        fontSize: theme.typography.subtitle_xs,
                        whiteSpace: "nowrap",
                        borderBottom: "none",
                        width: col.width,
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredItems.map((data, index) => {
                  // map filtered index back to real safeItems index
                  const realIndex = safeItems.findIndex(
                    (item) => item === data,
                  );
                  const idx = realIndex >= 0 ? realIndex : index;

                  const totalReturnedQty = (returns || [])
                    .filter(
                      (r: AnyForNow) =>
                        String(r.productcode) === String(data.productcode) &&
                        String(r.sts) === CON_STATUS_RETURNAPPROVED,
                    )
                    .reduce(
                      (sum: number, r: AnyForNow) =>
                        sum + Number(r.returnedqty ?? 0),
                      0,
                    );

                  const pendingApprovalQty = (returns || [])
                    .filter(
                      (r: AnyForNow) =>
                        String(r.productcode) === String(data.productcode) &&
                        String(r.sts) === CON_STATUS_RETURNSUBMITTED,
                    )
                    .reduce(
                      (sum: number, r: AnyForNow) =>
                        sum + Number(r.returnedqty ?? 0),
                      0,
                    );

                  // Returnable = acceptedqty - all previously returned qty
                  const returnableQty = Math.max(
                    0,
                    Number(data.acceptedqty ?? 0) - totalReturnedQty,
                  );

                  return (
                    <React.Fragment key={idx}>
                      {/* ── Main row ── */}
                      <TableRow
                        sx={{
                          bgcolor: selectedRows[idx]
                            ? "action.selected"
                            : "background.paper",
                          borderBottom: expandedOptional[idx]
                            ? "none"
                            : `1px solid`,
                          borderColor: "divider",
                          transition: "background-color 0.15s ease",
                        }}
                      >
                        {/* Checkbox cell */}
                        <TableCell
                          align="center"
                          sx={{ py: 1.25, px: 1, verticalAlign: "middle" }}
                        >
                          <Checkbox
                            size="small"
                            checked={!!selectedRows[idx]}
                            onChange={(e) =>
                              handleRowSelect(idx, e.target.checked)
                            }
                            sx={{
                              display: "none",
                            }}
                          />
                        </TableCell>

                        {/* Expand */}
                        <TableCell
                          align="center"
                          sx={{ py: 1.25, px: 1, verticalAlign: "middle" }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => toggleOptionalFields(idx)}
                          >
                            {expandedOptional[idx] ? (
                              <ExpandLess fontSize="small" />
                            ) : (
                              <ExpandMore fontSize="small" />
                            )}
                          </IconButton>
                        </TableCell>

                        {/* Item Details */}
                        <TableCell
                          sx={{ py: 1.25, px: 1.5, verticalAlign: "middle" }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "0.85rem",
                              lineHeight: 1.3,
                              color: "text.primary",
                            }}
                          >
                            {data.productname || "-"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: theme.typography.subtitle_xs,
                              color: "text.secondary",
                              mt: 0.2,
                            }}
                          >
                            Item Code: {data.productcode || "-"}
                          </Typography>
                        </TableCell>

                        {/* Item Description */}
                        <TableCell
                          sx={{ py: 1.25, px: 1.5, verticalAlign: "middle" }}
                        >
                          <Typography
                            sx={{ fontSize: "0.83rem", color: "text.primary" }}
                          >
                            { "-"}
                          </Typography>
                        </TableCell>

                        {/* Batch Number */}
                        <TableCell
                          sx={{ py: 1.25, px: 1.5, verticalAlign: "middle" }}
                        >
                          <Typography sx={{ fontSize: "0.83rem" }}>
                            {data.batchno || "-"}
                          </Typography>
                        </TableCell>

                        {/* Returnable Quantity */}
                        <TableCell
                          align="center"
                          sx={{ py: 1.25, px: 1.5, verticalAlign: "middle" }}
                        >
                          <Tooltip
                            title={`Pending Approval Return Qty: ${pendingApprovalQty}`}
                            arrow
                          >
                            <Typography sx={{ fontSize: "0.83rem" }}>
                              {returnableQty}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        {/* Return Quantity */}
                    
                       <TableCell sx={{ py: 1, px: 1.5, verticalAlign: "middle" }}>
  <TextField
    variant="outlined"
    size="small"
    fullWidth
    required
    name="returnQuantity"
    value={returnQuantities[idx]}
    label="Return Quantity"
    sx={{
       
                              "& .MuiOutlinedInput-root": {
          borderRadius: 1.5,
          fontSize: "0.83rem",
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.83rem",
        },
    }}
    InputLabelProps={{
      shrink: isPreFilled(idx) || undefined,
      sx: {
        fontSize: isPreFilled(idx) ? "0.83rem" : "0.83rem",
      },
    }}
    onChange={(e) => {
      const value = e.target.value;
      const newQuantities = [...returnQuantities];
      const newErrors = [...quantityErrors];

      // ── Hard block: nothing returnable, don't allow any value to be set ──
      if (returnableQty <= 0) {
        newErrors[idx] = "No returnable quantity available for this item";
        newQuantities[idx] = "";
        setReturnQuantities(newQuantities);
        setQuantityErrors(newErrors);
        setSelectedRows((prev) => {
          const u = [...prev];
          u[idx] = false;
          return u;
        });
        return;
      }

      if (value === "") {
        newErrors[idx] = "";
        newQuantities[idx] = "";
        setReturnQuantities(newQuantities);
        setQuantityErrors(newErrors);
        setSelectedRows((prev) => {
          const u = [...prev];
          u[idx] = false;
          return u;
        });
        return;
      }

      if (!/^\d+$/.test(value)) {
        newErrors[idx] = "Only numbers are allowed";
        setQuantityErrors(newErrors);
        setSelectedRows((prev) => {
          const u = [...prev];
          u[idx] = false;
          return u;
        });
        return;
      }

      const numericValue = Number(value);

      // ── Recalculate returnableQty fresh inside handler ──
      const totalReturnedQtyFresh = (returns || [])
        .filter(
          (r: AnyForNow) =>
            String(r.productcode) === String(data.productcode) &&
            String(r.sts) === CON_STATUS_RETURNAPPROVED,
        )
        .reduce(
          (sum: number, r: AnyForNow) => sum + Number(r.returnedqty ?? 0),
          0,
        );

      const freshReturnableQty = Math.max(
        0,
        Number(data.acceptedqty ?? 0) - totalReturnedQtyFresh,
      );

      // ── Hard cap is always the returnable quantity — no fallback ──
      const effectiveMax = freshReturnableQty;

      if (effectiveMax <= 0) {
        newErrors[idx] = "No returnable quantity available for this item";
        newQuantities[idx] = "";
        setReturnQuantities(newQuantities);
        setQuantityErrors(newErrors);
        setSelectedRows((prev) => {
          const u = [...prev];
          u[idx] = false;
          return u;
        });
        return;
      }

      if (numericValue > effectiveMax) {
        // ── Blocked: show error, keep checkbox checked only if current value is still valid ──
        const currentValid =
          Number(returnQuantities[idx]) > 0 &&
          Number(returnQuantities[idx]) <= effectiveMax;

        newErrors[idx] = `Cannot exceed Returnable quantity of ${effectiveMax}`;

        setQuantityErrors(newErrors);
        setSelectedRows((prev) => {
          const updated = [...prev];
          updated[idx] = currentValid;
          return updated;
        });
        return;
      }

      if (numericValue <= 0) {
        newErrors[idx] = "Must be greater than 0";
        setQuantityErrors(newErrors);
        setSelectedRows((prev) => {
          const u = [...prev];
          u[idx] = false;
          return u;
        });
        return;
      }

      // ── Valid: clear error and auto-check ──
      newErrors[idx] = "";
      newQuantities[idx] = value;
      setReturnQuantities(newQuantities);
      setQuantityErrors(newErrors);
      setSelectedRows((prev) => {
        const updated = [...prev];
        updated[idx] = true;
        return updated;
      });
    }}
    error={Boolean(
      quantityErrors[idx] ||
        (returnableQty <= 0) ||
        (shouldShowSelectionError
          ? "Please enter return details for at least one item."
          : ""),
    )}
    helperText={
      quantityErrors[idx] ||
      (returnableQty <= 0 ? "No returnable quantity " : "")
    }
    FormHelperTextProps={{
      sx: { fontSize: "11px", color: "error.main" },
    }}
    inputProps={{
      inputMode: "numeric",
      style: { textAlign: "center" },
      onKeyDown: (e) => {
        if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
      },
    }}
    
  />
</TableCell>
                     

                        {/* Reason for Return */}
                        <TableCell
                          sx={{ py: 1.2, px: 1.5, verticalAlign: "middle" }}
                        >
<Autocomplete
  fullWidth
  size="small"
  options={reasonOptions}
  value={
    reasonOptions.find(
      (option) => (option.descrip || option) === reasons[idx]
    ) || null
  }
  loading={loading}
  disabled={loading}
  getOptionLabel={(option) =>
    typeof option === "string" ? option : option.descrip || ""
  }
  isOptionEqualToValue={(option, value) =>
    (option.descrip || option) === (value.descrip || value)
  }
  onChange={(event, newValue) => {
    const newReasons = [...reasons];

    newReasons[idx] = newValue
      ? typeof newValue === "string"
        ? newValue
        : newValue.descrip
      : "";

    setReasons(newReasons);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Reason"
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 1.5,
          fontSize: "0.83rem",
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.83rem",
        },
      }}
    />
  )}
  renderOption={(props, option) => (
    <li {...props} style={{ fontSize: "0.83rem" }}>
      {typeof option === "string" ? option : option.descrip}
    </li>
  )}
/>
                        </TableCell>

                        {/* Remark */}
                        <TableCell
                          sx={{ py: 1.25, px: 1.5, verticalAlign: "middle" }}
                        >
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            name="returnRemarks"
                            value={returnRemarks[idx]}
                            label="Remark"
                            
                            onChange={(e) => {
                              const newRemarks = [...returnRemarks];
                              const newErrors = [...returnRemarkErrors];
                              const value = e.target.value;
                              if (value === "") {
                                newErrors[idx] = "";
                                newRemarks[idx] = "";
                                setReturnRemarks(newRemarks);
                                setReturnRemarkErrors(newErrors);
                                return;
                              }
                              newRemarks[idx] = value;
                              setReturnRemarks(newRemarks);
                              setReturnRemarkErrors(newErrors);
                            }}
                            error={!!returnRemarkErrors[idx]}
                            helperText={returnRemarkErrors[idx]}
                            FormHelperTextProps={{
                              sx: { fontSize: "11px", color: "error.main" },
                            }}
                            sx={{
                             
                              "& .MuiOutlinedInput-root": {
          borderRadius: 1.5,
          fontSize: "0.83rem",
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.83rem",
        },
                            }}
                          />
                        </TableCell>

                        {/* Action */}
                        <TableCell
                          align="center"
                          sx={{ py: 1.25, px: 1, verticalAlign: "middle" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 0.25,
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, idx)}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                            <Menu
                              anchorEl={anchorEl[idx]}
                              open={Boolean(anchorEl[idx])}
                              onClose={() => handleMenuClose(idx)}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              PaperProps={{
                                elevation: 2,
                                sx: {
                                  borderRadius: 1.5,
                                  minWidth: 160,
                                  border: "1px solid",
                                  borderColor: "divider",
                                  "& .MuiMenuItem-root": {
                                    fontSize: "0.83rem",
                                    gap: 1,
                                    py: 1,
                                    px: 1.5,
                                  },
                                },
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  handleMenuClose(idx);
                                  toggleOptionalFields(idx);
                                  navigate(GRN_ROUTES.View_TEP_HISTORY, {
                                    state: {
                                      grncode,
                                      trsts,
                                      trcatcode,
                                      origin:
                                        GRN_VIEW_RETURN_FILTER.ORIGIN_RETURN,
                                    },
                                  });
                                }}
                              >
                                <VisibilityOutlinedIcon
                                  fontSize="small"
                                  sx={{ color: "text.secondary" }}
                                />{" "}
                                View GRN
                              </MenuItem>
                              <Divider sx={{ my: 0.5 }} />
                              <MenuItem
                                onClick={() => {
                                  handleMenuClose(idx);
                                  setExpandedOptional((prev) => ({
                                    ...prev,
                                    [idx]: true,
                                  }));
                                  setItemAttachments((prev) => {
                                    const updated = [...prev];
                                    updated[idx] = true;
                                    return updated;
                                  });
                                }}
                              >
                                <AttachFileOutlinedIcon
                                  fontSize="small"
                                  sx={{ color: "text.secondary" }}
                                />{" "}
                                Attachments
                              </MenuItem>
                            </Menu>
                          </Box>
                        </TableCell>
                      </TableRow>

                      {/* ── Additional Details panel ── */}
                      {expandedOptional[idx] && (
                        <TableRow>
                          <TableCell
                            colSpan={10}
                            sx={{
                              p: 0,
                              borderBottom: `1px solid`,
                              borderColor: "divider",
                              bgcolor: theme.palette.background.paper,
                            }}
                          >
                            <Box sx={{ p: 2 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  mb: 1.5,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: theme.typography.subtitle_xs,
                                    fontWeight: 700,
                                    letterSpacing: "0.08em",
                                    color: "text.secondary",
                                  }}
                                >
                                  Additional Details
                                </Typography>
                              </Box>

                              {/* Detail cards — row 1 */}
                              <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                                {[
                                  {
                                    label: "UOM",
                                    value: data.immeasuringunit || "-",
                                  },
                                 {
  label: "GRN Quantity",
  value:
    (Number(data?.acceptedqty || 0) + Number(data?.freeqty || 0)).toString(),
},
                                  {
                                    label: "Previously Return Quantity",
                                    value: totalReturnedQty,
                                  },
                                  {
                                    label: "Model Name",
                                    value:
                                      data.modelno === "N/A"
                                        ? "-"
                                        : data.modelno || "-",
                                  },
                                ].map((card) => (
                                  <Grid
                                    key={card.label}
                                    size={{ xs: 6, sm: 3, md: 3, lg: 3 }}
                                  >
                                    <Box
                                      sx={{
                                        border: `1px solid`,
                                        borderColor: "divider",
                                        borderRadius: 1.5,
                                        p: 1.25,
                                        bgcolor: "background.default",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize:
                                            theme.typography.subtitle_xs,
                                          fontWeight: 700,
                                          color: "text.disabled",
                                          mb: 0.5,
                                        }}
                                      >
                                        {card.label}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "0.88rem",
                                          color: "text.primary",
                                        }}
                                      >
                                        {card.value}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                ))}
                              </Grid>

                              {/* Detail cards — row 2 */}
                              <Grid container spacing={1.5}>
                                {[
                                  {
                                    label: "Generic Name",
                                    value:
                                      data.genericname === "N/A"
                                        ? "-"
                                        : data.genericname || "-",
                                    size: 3,
                                  },
                                  {
                                    label: "Serial Number",
                                    value: data.serialno || "-",
                                    size: 3,
                                  },
                                  {
                                    label: "Package Type",
                                    value:
                                      data.packagename === "N/A"
                                        ? "-"
                                        : data.packagename || "-",
                                    size: 6,
                                  },
                                ].map((card) => (
                                  <Grid
                                    key={card.label}
                                    size={{
                                      xs: 6,
                                      sm: card.size as any,
                                      md: card.size as any,
                                      lg: card.size as any,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        border: `1px solid`,
                                        borderColor: "divider",
                                        borderRadius: 1.5,
                                        p: 1.25,
                                        bgcolor: "background.default",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize:
                                            theme.typography.subtitle_xs,
                                          fontWeight: 700,
                                          color: "text.disabled",
                                          mb: 0.5,
                                        }}
                                      >
                                        {card.label}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize:
                                            theme.typography.subtitle_xs,
                                          color: "text.primary",
                                        }}
                                      >
                                        {card.value}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                ))}
                              </Grid>

                              {/* Attachments sub-section */}
                              {showItemAttachments[idx] && (
                                <Box sx={{ mt: 2 }}>
                                  <Divider sx={{ mb: 1.5 }} />
                                  <Typography
                                    sx={{
                                      fontSize: theme.typography.body_s,
                                      fontWeight: 700,
                                      letterSpacing: "0.07em",
                                      color: "text.secondary",
                                      mb: 1,
                                    }}
                                  >
                                    Attachments
                                  </Typography>
                                  <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                  >
                                    <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                                      <Box sx={styles.grn_action_items_box1}>
                                        <Upload
                                          MAX_FILESIZE={5 * 1024 * 1024}
                                          setSnackbarMessage={() => {}}
                                          setOpenErrorSnackbar={() => {}}
                                          setFilePath={() => {}}
                                          onFileSelect={async (
                                            fileName: string,
                                            base64DataURL: string,
                                            rawFile: File,
                                          ) => {
                                            await handleFileSelect(
                                              fileName,
                                              base64DataURL,
                                              rawFile,
                                              idx,
                                            );
                                          }}
                                          fileName={
                                            fileName[idx] || "No file selected"
                                          }
                                          setFileName={(name) => {
                                            setFileName((prev) => {
                                              const updated = [...prev];
                                              updated[idx] = name;
                                              return updated;
                                            });
                                          }}
                                          objectUrl=""
                                          resetKey={dtoDocs[idx] ? 1 : 0}
                                        />
                                      </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                                      <Box sx={styles.grn_action_items_box1}>
                                        {(() => {
                                          const hasRealAttachment =
                                            dtoDocs[idx] &&
                                            dtoDocs[idx].doctypecode !== "0" &&
                                            dtoDocs[idx].FILEPATH &&
                                            !dtoDocs[idx].FILEPATH.includes(
                                              "noimage.png",
                                            );
                                          const hasDefaultNoImage =
                                            dtoDocs[idx] &&
                                            dtoDocs[idx].doctypecode === "0" &&
                                            dtoDocs[idx].FILEPATH &&
                                            dtoDocs[idx].FILEPATH.includes(
                                              "noimage.png",
                                            );
                                          if (hasRealAttachment) {
                                            return (
                                              <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="center"
                                                sx={{ position: "relative" }}
                                                p={1}
                                              >
                                                {isImageFile(
                                                  dtoDocs[idx].FILENAME ||
                                                    dtoDocs[idx]?.filename ||
                                                    dtoDocs[idx]?.FILEPATH ||
                                                    dtoDocs[idx]?.bytarr ||
                                                    dtoDocs[idx].fileUrl,
                                                ) ? (
                                                  <Tooltip
                                                    title={
                                                      dtoDocs[idx].FILENAME ||
                                                      "Attachment"
                                                    }
                                                    placement="top"
                                                  >
                                                    <img
                                                      src={
                                                        dtoDocs[idx].bytarr
                                                          ? getBase64ImageSrc(
                                                              dtoDocs[idx]
                                                                .bytarr,
                                                              dtoDocs[idx]
                                                                .filename,
                                                            )
                                                          : dtoDocs[idx]
                                                              .fileUrl ||
                                                            dtoDocs[idx]
                                                              .FILEPATH
                                                      }
                                                      alt={
                                                        dtoDocs[idx].FILENAME ||
                                                        "Attachment"
                                                      }
                                                      style={{
                                                        width: 48,
                                                        height: 48,
                                                        objectFit: "cover",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => {
                                                        const fullImg = getBase64ImageSrc(
                                                          dtoDocs[idx].bytarr,
                                                          dtoDocs[idx].filename,
                                                        );
                                                        setSelectedImage({
                                                          url:
                                                            fullImg ||
                                                            dtoDocs[idx]
                                                              .fileUrl ||
                                                            dtoDocs[idx]
                                                              .FILEPATH,
                                                          name:
                                                            dtoDocs[idx]
                                                              .filename ||
                                                            "Attachment",
                                                          description:
                                                            dtoDocs[idx]
                                                              .remark || "",
                                                        });
                                                        setImagePreviewOpen(
                                                          true,
                                                        );
                                                      }}
                                                    />
                                                  </Tooltip>
                                                ) : (
                                                  <InsertDriveFileIcon
                                                    style={{
                                                      width: 48,
                                                      height: 48,
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                      const fullImg = getBase64ImageSrc(
                                                        dtoDocs[idx].bytarr,
                                                        dtoDocs[idx].filename,
                                                      );
                                                      setSelectedImage({
                                                        url:
                                                          dtoDocs[idx]
                                                            .fileUrl ||
                                                          dtoDocs[idx]
                                                            .FILEPATH ||
                                                          fullImg,
                                                        name:
                                                          dtoDocs[idx]
                                                            .filename ||
                                                          "Document",
                                                        description:
                                                          dtoDocs[idx].remark ||
                                                          "",
                                                      });
                                                      setImagePreviewOpen(true);
                                                    }}
                                                  />
                                                )}
                                                <IconButton
                                                  size="small"
                                                  color="error"
                                                  sx={{
                                                    position: "absolute",
                                                    top: 0,
                                                    right: 0,
                                                    zIndex: 100,
                                                  }}
                                                  onClick={() =>
                                                    handleItemAttachmentRemove(
                                                      idx,
                                                    )
                                                  }
                                                >
                                                  <ClearIcon fontSize="small" />
                                                </IconButton>
                                              </Box>
                                            );
                                          }
                                          return (
                                            <Box
                                              display="flex"
                                              flexDirection="column"
                                              alignItems="center"
                                              p={1}

                                              sx={{ filter: (theme) =>
      theme.palette.mode === "dark"
        ? "invert(1)"
        : "none",}}
                                            >
                                              <Tooltip
                                                title="No attachment"
                                                placement="top"
                                              >
                                                <img
                                                  src={
                                                    hasDefaultNoImage
                                                      ? dtoDocs[idx].FILEPATH
                                                      : CON_DEFAULT_IMG
                                                  }
                                                  alt="No attachment"
                                                  style={{
                                                    width: 48,
                                                    height: 48,
                                                    objectFit: "cover",
                                                    cursor: "default",
                                                  }}
                                                />
                                              </Tooltip>
                                            </Box>
                                          );
                                        })()}
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Box>
                              )}
                              {/* No per-row Save button here anymore */}
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>

            <ImagePopUp
              open={imagePopupOpen}
              handleClose={() => setImagePopupOpen(false)}
              image={popupImage}
              name={popupName}
              description={popupDescription}
            />
            <ImagePopUp
              open={imagePreviewOpen}
              handleClose={() => setImagePreviewOpen(false)}
              image={selectedImage?.url}
              name={selectedImage?.name}
              description={selectedImage?.description}
              objectUrl={selectedImage?.objectUrl}
            />
          </TableContainer>

          {/* ── Single Save button at the bottom ── */}
        </Collapse>
      </Paper>

      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default ReturnItemsTableviewdet;
